<script>
/**
 * Left sidebar component - contains mainly the application menu
 */
export default {
  props: {
    qfcontent: {
      type: Object,
      required: false,
      default: () => ({}),
    },
  },
  data() {
    return {
      settings: {
        minScrollbarLength: 60,
      },
      correctAnswer: this.qfcontent.answers[0],
      suffeledAnswersList: this.qfcontent.answers,
    }
  },
  methods: {
    getAccessLevelColor(item) {
      if (item === 'Administrator') return 'badge-soft-danger'
      else if (item === 'Editor') return 'badge-soft-secondary'
      else if (item === 'User') return 'badge-soft-success'
      else if (item === 'Union Administrator') return 'badge-soft-primary'
      else if (item === 'Federation Administrator') return 'badge-soft-info'
      else return 'badge-soft-dark'
    },
    myRowClickHandler(content) {
      console.log(content.id + ' - ' + content.title + ' - ' + content.story) // This will be the item data for the row
      this.$router.push({
        name: 'SubChapters',
        params: { content: content, id: content.id },
      })
    },
    randomize() {
      var tempAllNoneIndex = 0
      var tempAllNoneItem = ''
      var tempItem = ''
      shuffleVueArray(this.suffeledAnswersList)
      for (let i = 0; i < this.suffeledAnswersList.length; i++) {
        if (
          this.suffeledAnswersList[i] == 'All' ||
          this.suffeledAnswersList[i] == 'None' ||
          this.suffeledAnswersList[i] == 'Both'
        ) {
          tempAllNoneIndex = i
          tempAllNoneItem = this.suffeledAnswersList[i]
          tempItem =
            this.suffeledAnswersList[this.suffeledAnswersList.length - 1]

          this.suffeledAnswersList[this.suffeledAnswersList.length - 1] =
            tempAllNoneItem
          this.suffeledAnswersList[tempAllNoneIndex] = tempItem
        }
        //else ;
      }
    },
    handleClick(answer, correctAnswer) {
      this.$emit("send", answer, correctAnswer)
    }
  },
  computed: {},
  watch: {},
  mounted() {
    //console.log('>>>>>> Content: ' + qfcontent.title)
    this.randomize()
  },
  created() {
    //this.randomize()
  },
}
import Vue from 'vue'
function shuffleVueArray(array) {
  for (let i = array.length - 1; i > 0; i--) {
    const j = Math.floor(Math.random() * (i + 1))
    const temp = array[i]
    Vue.set(array, i, array[j])
    Vue.set(array, j, temp)
  }
}
</script>

<template>
  <!--div
    class="row row-class"
    style="
      position: relative;
      top: 50%;
      transform: translateY(-50%);
      justify-content: center;
      padding:4em
    "
  >
  <div
    style="display:inline-block;
      width:10px;
      height:10px">
  <img src="../assets/images/click.png"/>
  </div>
  <div
    class="column column-class"
    style="
    display:inline-block;
      position: relative;
      top: 50%;
      transform: translateY(-50%);
      justify-content: center;
      padding:4em
    "
  >
    <div><h3>{{ qfcontent.title }}</h3></div>
    <div><h5>{{ qfcontent.description }}</h5></div>
    <div style="padding-top: 1em"
      v-for="(answer, index) in this.suffeledAnswersList"
      :key="index"
    >
      <b-button v-if="answer.length" variant="primary">{{ answer }}</b-button>
    </div>
  </div>
</div-->
  <!-- background-color: #EFFBFE -->
  <div class="row row-class" style="padding:4em;">
    <div class="col-md-2 col-lg-2 col-sm-12 col-xl-2" style="padding-top: 1em;">
      <!--img src="../assets/images/click.png" class="imageClass" style="margin-right: auto; display: block;" /-->
      <img :src="qfcontent.updatedBy" class="imageClass" style="margin-right: auto; display: block;" />
    </div>
    <div class="col-md-10 col-lg-10 col-sm-12 col-xl-10">
      <div>
        <!--h3>{{ qfcontent.id }}</h3-->
        <h3>{{ qfcontent.title }}</h3>
      </div>
      <div>
        <h5>{{ qfcontent.description }}</h5>
      </div>
      <div style="margin-top: 1px">
        &nbsp;
      </div>
      <div v-for="(answer, index) in this.suffeledAnswersList" :key="index" style="margin-top: 6px">
       
          <b-button v-if="answer.length" class="text-left" variant="primary" @click="handleClick(answer, correctAnswer)">{{ answer }}
          </b-button>
        
      </div>
    </div>
  </div>
</template>

<style lang="scss">
.grid {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 100px;
}

.imageClass {
    width: 100px;
    height: auto;
}
/* sm */
@media (min-width: 768px) {
    .imageClass {
        width: 50px;
    }
}
/* md */
@media (min-width: 992px) {
    .imageClass {
        width: 80px;
    }
}
/* lg */
@media (min-width: 1200px) {
    .imageClass {
        width: 100px;
    }
}

#textbox {
  display: flex;
  flex-flow: row wrap;
}

.alignleft {
  width: 50%;
  text-align: left;
  font-weight: 100;
  font-size: 12px;
  line-height: 10px;
  color: white;
}

.alignright {
  width: 50%;
  text-align: right;
  font-weight: 100;
  font-size: 12px;
  line-height: 10px;
  color: white;
}

.cardd {
  height: 350px;
  width: 100%;
  background-color: rgba(255, 255, 255, 0.06);
  backdrop-filter: blur(10px);
  position: relative;
  border-radius: 16px;
  margin-bottom: 16px;
  //box-shadow: 5px 5px 5px rgba(0, 0, 0, 0.1);
}

.card-img {
  height: 350px;
  width: 100%;
  background-color: rgba(255, 255, 255, 0.06);
  backdrop-filter: blur(10px);
  position: relative;
  margin: 0px auto 0px auto;
  left: 0;
  right: 0;
  border-radius: 16px;
}

.card-img img {
  height: 100%;
  width: 100%;
  border-radius: 16px;
  object-fit: cover;
}

.desc {
  width: 100%;
  text-align: left;
  position: absolute;
  top: 16px;
  left: 16px;
}

.primary-text {
  color: #ffffff;
  font-size: 18px;
  font-weight: 300;
  letter-spacing: 0.7px;
  margin: 5px 0;
  text-shadow: 1px 1px #000000;
  text-overflow: ellipsis;
  overflow: hidden;
  white-space: nowrap;
}

.secondary-text {
  color: #ffffff;
  font-weight: 100;
  font-size: 12px;
  letter-spacing: 1px;
  margin: 5px 0;
  text-overflow: ellipsis;
  overflow: hidden;
  // Addition lines for 2 line or multiline ellipsis
  display: -webkit-box !important;
  -webkit-line-clamp: 3;
  -webkit-box-orient: vertical;
  white-space: normal;
}

.coveredSoFar {
  width: 100%;
  font-weight: 100;
  font-size: 12px;
  line-height: 30px;
}

.bottom {
  width: 100%;
  display: inline-block;
  align-self: flex-end;
}

.details {
  width: 100%;
  height: 50%;
  position: absolute;
  bottom: 0;
  background-color: rgba(0, 0, 0, 0.185);
  backdrop-filter: blur(10px);
  border-radius: 0 0 16px 16px;
  padding: 15px;
  display: flex;
}

.details>div {
  text-align: left;
}

.buttonn {
  background-color: rgba(0, 0, 0, 0.06);
  backdrop-filter: blur(10px);
  position: absolute;
  width: 80%;
  left: 10%;
  top: 240px;
  border: none;
  border-radius: 5px;
  padding: 15px 0;
}

.coffe {
  position: absolute;
  left: 50px;
  bottom: 50px;
  transition: all 0.6s ease-in-out;
}

.coffe:hover {
  transform: scale(1.2);
}

.fs-12 {
  font-size: 10px !important;
}

.custom_badge {
  display: inline-block;
  padding: 0.25 em 0.4 em;
  font-size: 70%;
  font-weight: 500;
  line-height: 1.2;
  color: #fff;
  text-align: center;
  white-space: nowrap;
  vertical-align: baseline;
  border-radius: 0.75 rem;
}

.custom_card {
  position: relative;
  display: flex;
  flex-direction: column;
  min-width: 0;
  word-wrap: break-word;
  background-color: #fff;
  background-clip: border-box;
  border: 1 px solid #e2e7f1;
  border-radius: 0.25 rem;
}

.custom_img {
  border-radius: 16px 16px 0px 0px;
  object-fit: contain;
  display: flex;
  width: 100%;
  height: 100%;
}

.custom_loader_img {
  border-radius: 5px 5px 0px 0px;
  height: 140px;
  object-fit: scale-down;
  display: block;
  width: 100%;
}

.custom_card-body {
  flex: 1 1 auto;
  padding: 15px 25px 5px 0px;
}

.custom_align-items-left {
  align-items: left !important;
}

.col-sm-auto {
  flex: 0 0 auto;
  width: auto;
}
</style>
